interface ResolveSelectedRelationInput {
  relationOptions: readonly { value: string }[];
  selectedRelationOverride: string | null;
  preselectedRelation?: string;
}

export function resolveSelectedRelation({
  relationOptions,
  selectedRelationOverride,
  preselectedRelation,
}: ResolveSelectedRelationInput): string {
  console.info("[RelatedEventSelectionModel::resolveSelectedRelation]");
  return (
    selectedRelationOverride ||
    preselectedRelation ||
    relationOptions[0]?.value ||
    ""
  );
}
